import React from 'react';
import FormGroup from 'jd-library/FormGroup';
import FormControl from 'jd-library/FormControl';
import style from './input-search.scss';
import MobileFilterRipple from './MobileFilterRipple';

const InputSearch = React.forwardRef((
    {
        placeholder,
        className,
        searchText,
        onKeyUp,
        onChange,
        label,
        ...props
    },
    ref
) => {

    return (
        <FormGroup className={`${className} ${style['input-search']}`}>
            <div className={style['input-icon-holder']}>
                <FormControl
                    ref={ref}
                    placeholder={placeholder}
                    onChange={(e) => props.onInputChange(e)}
                    value={searchText}
                    className={`${style['searchbox']} ${!searchText ? style['empty-searchbox'] : ''}`}
                />
                <i className={`${style['left-icon']} icon-HDRsearch`}></i>
                {searchText && (
                    <MobileFilterRipple className={`${style['close-span']}`} clickHandler={() => {setTimeout(() => {
                        props.onInputChange(false)
                    }, 300);}}>
                        <i className={`${style['right-icon']} icon-HDRcross`}></i>
                    </MobileFilterRipple>
                )}

            </div>
        </FormGroup>
    );
})

export default InputSearch;